/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

	
    jQuery(document).on('scroll',function(){

      	
      
      if(jQuery('#checkLoadItem').length > 0){
      	var homeCollectionSlider = jQuery('div#shopify-section-16157708198fc529d7 .collection-list.collection-list--carousel.js-home-collection-list .collection-list__items .o-layout--center');
      	function addClassToSlide() {
            homeCollectionSlider
                .find(".slick-current")
                .addClass("js-slide-seen");
        }
		    
          homeCollectionSlider.removeClass('layout-slider--loading');

            homeCollectionSlider.not(".slick-initialized").slick({
                slidesToShow: 3,
                infinite: true,
                dots: false,
                arrows: true,
                centerPadding: "30px",
              	lazyLoad: 'progressive',
              	autoplay: true,
              	responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 2,
                        dots: false,
                        autoplay: true,
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                        dots: false,
                        autoplay: true,
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        dots: false,
                        autoplay: true,
                      }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                  ]
            });
          homeCollectionSlider.on("afterChange", addClassToSlide);
      }
      
    });

jQuery(document).ready(function(){

      	
      
      
      	var homeCollectionSlider = jQuery('div#shopify-section-16157708198fc529d7 .collection-list.collection-list--carousel.js-home-collection-list .collection-list__items .o-layout--center');
      	function addClassToSlide() {
            homeCollectionSlider
                .find(".slick-current")
                .addClass("js-slide-seen");
        }
		    
          homeCollectionSlider.removeClass('layout-slider--loading');

            homeCollectionSlider.not(".slick-initialized").slick({
                slidesToShow: 3,
                infinite: true,
                dots: false,
                arrows: true,
                centerPadding: "30px",
              	lazyLoad: 'progressive',
              autoplay: true,
              responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 2,
                        dots: false,
                        autoplay: true,
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                        dots: false,
                        autoplay: true,
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        dots: false,
                        autoplay: true,
                      }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                  ]
            });
          homeCollectionSlider.on("afterChange", addClassToSlide);
      
      
    });

jQuery(document).ready(function(){
// 	$("div#acc-2").next().attr("href","/pages/faqs");
  
  
  const sel = document.querySelectorAll('.custom-select-home');
  sel.forEach(element => {
  	element.addEventListener('change', function(e){
      $(this).parent().parent().find('button.c-btn.c-btn--full.c-btn--plus.c-btn--primary.product-single__add-btn.js-product-add').click();
    });
    
  	
  })
  
  
})

	
